// extracted by mini-css-extract-plugin
export default {"root":"doctors_root__8t23Y max-w-[1053px] w-full mx-auto"};